import React from 'react';
import { SectionContainer } from 'components/grid';
import { Typography } from '@tkww/the-bash-frontend';
import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';

const StyledBottomCurve = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.green[50],
  width: '100%',
  height: 318,
  clipPath: 'ellipse(83% 70% at 50% 22%)',
  bottom: 0,
  paddingTop: 58,
  [theme.breakpoints.up('md')]: {
    height: 250,
    clipPath: 'ellipse(58% 68% at 50% 22%)',
  },
  [theme.breakpoints.up('lg')]: {
    height: 202,
    clipPath: 'ellipse(58% 77% at 50% 22%)',
  },
}));

const Hero = () => (
  <StyledBottomCurve>
    <SectionContainer backgroundColor="transparent" sx={{ textAlign: 'center' }}>
      <Typography variant="h1" margin="0 auto 24px" fontSize={36}>
        Booking Guarantee
      </Typography>
      <Typography variant="body1" maxWidth={688} margin="0 auto">
        {`From looking to booking, we've got you covered. Our Booking Benefits are always included
        when you secure your booking through The Bash!`}
      </Typography>
    </SectionContainer>
  </StyledBottomCurve>
);

export default Hero;
